function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import classNames from 'classnames';
import React from 'react';
import { renderErrors } from "../../utils";
import { hasError } from "../../utils/hasError/hasError";
import { Button } from '..';
import { CharsCouterContainer, CharsNumber, ClearIconWrapper, ErrorMessage, MaxChars, TextareaContent, TextareaLabel, TextareaText, TextareaWrapper } from "./Textarea.styles";
export var Textarea = function Textarea(_ref) {
  var input = _ref.input,
      disabled = _ref.disabled,
      meta = _ref.meta,
      label = _ref.label,
      style = _ref.style,
      clearable = _ref.clearable,
      _ref$resizeable = _ref.resizeable,
      resizeable = _ref$resizeable === void 0 ? true : _ref$resizeable,
      className = _ref.className,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 4 : _ref$rows,
      charsCounter = _ref.charsCounter,
      maxLenght = _ref.maxLenght;
  var isError = hasError(meta, disabled);

  var handleClear = function handleClear() {
    return input.onChange('');
  };

  var paddingStyle = {
    paddingRight: clearable || charsCounter ? '3.5rem' : undefined
  };

  var handleOnChange = function handleOnChange(event) {
    if (!maxLenght || event.target.value.length <= maxLenght) {
      input.onChange(event);
    } else {
      input.onChange(input.value);
    }
  };

  return React.createElement(TextareaWrapper, {
    style: style,
    className: classNames(className, 'textarea', isError && 'textarea--error')
  }, React.createElement(TextareaContent, {
    className: "textarea__content"
  }, React.createElement(TextareaText, _extends({}, input, {
    onChange: handleOnChange,
    isFilled: !!input.value,
    hasError: isError,
    isModified: meta.dirty,
    disabled: disabled,
    style: paddingStyle,
    rows: rows,
    resizeable: resizeable,
    className: classNames('textarea__field', isError && 'textarea__field--error')
  })), React.createElement(TextareaLabel, {
    style: paddingStyle,
    htmlFor: input.name,
    className: "textarea__label"
  }, label), clearable && input.value && React.createElement(ClearIconWrapper, null, React.createElement(Button, {
    type: Button.types.ICON,
    onClick: handleClear,
    icon: 'closeM'
  })), charsCounter && React.createElement(CharsCouterContainer, null, React.createElement(CharsNumber, {
    className: "textarea__chars-number"
  }, input.value.length), maxLenght && React.createElement(MaxChars, {
    className: "textarea__max-number"
  }, "/", maxLenght))), isError && React.createElement(ErrorMessage, {
    className: "textarea__error"
  }, renderErrors(meta.error, meta.submitError)));
};